import { signalStore, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withSelectedEntity } from '../../../../shared/store/selected-entity.feature';
import { Livrable } from '../models/livrable.model';
import { avecMéthodesLivrables } from './livrable.methods';
import { avecSélecteursLivrables } from './livrable.selectors';
import { initialState } from './livrable.state';

export const LivrableStore = signalStore(
  { providedIn: 'root' },
  withEntities<Livrable>(),
  withState(initialState),
  withSelectedEntity(),
  avecMéthodesLivrables(),
  avecSélecteursLivrables(),
);
